export const AvatarTitle = {
    HI_I_AM_A: $localize`:@@avatar-title-hi-i-am-a:Hi! I am a`,
    I_AM_A: $localize`:@@avatar-title-i-am-a:I am a`,
    YO_I_AM_AN: $localize`:@@avatar-title-yo-i-am-an:Yo! I am an`,
    YO_I_AM: $localize`:@@avatar-title-yo-i-am:Yo! I am`,
    HI_I_AM_AN: $localize`:@@avatar-title-hi-i-am-an:Hi! I am an`,
} as const;

export const AvatarSubtitle = {
    DEVELOPER: $localize`:@@avatar-subtitle-developer:Developer`,
    SMM: $localize`:@@avatar-subtitle-smm:SMM`,
    CEO: $localize`:@@avatar-subtitle-ceo:CEO`,
    ACCOUNTANT: $localize`:@@avatar-subtitle-accountant:Accountant`,
    PROJECT_MANAGER: $localize`:@@avatar-subtitle-project-manager:Project manager`,
} as const;

export const RotatePosition = {
    EIGHT_DEG: 'rotate-[8deg] bottom-[38px]',
    FIVE_DEG: '-rotate-[5deg] bottom-[60px]',
    TWO_DEG: 'bottom-[58px] -rotate-[2deg]',
    ZERO_DEG: 'bottom-[55px]',
} as const;

export const AvatarSmile = {
    SMART: '🤓',
    CHILL: '😎',
    WINKY: '😉',
    STAR: '🤩',
} as const;
